const levelUpData = {
  Healer: {
    hitPoints: 1.15,
    attackPoints: 1.13,
    critBonus: 1,
    healBonus: 1.1,
  },
  Brawler: {
    hitPoints: 1.2,
    attackPoints: 1.12,
    critBonus: 1,
    healBonus: 1,
  },
  Specialist: {
    hitPoints: 1.2,
    attackPoints: 1.1,
    critBonus: 1.025,
    healBonus: 1,
  },
  Sad: {
    hitPoints: 1.1,
    attackPoints: 1.1,
    critBonus: 1,
    healBonus: 1,
  },
};

export default levelUpData;
